import React, { useEffect, useState } from 'react';
import CustomTabPanel from './customTabPanel';
import { AmountNegativeBalanceList } from './AmountNegativeBalanceList';
import { CreditNegativeBalanceList } from './CreditNegativeBalanceList';
// import { CreditInvoiceList } from './creditInvoice';

export const NegativeUsersBalanceList  = () => {
  const [selectedPanelStatus, setSelectedPanelStatus] = useState('Amount');
  const [load, setLoad] = useState(true);

  return (
    <>
      <CustomTabPanel setSelectedPanelStatus={setSelectedPanelStatus} setLoad={setLoad} />

      {selectedPanelStatus === 'Amount' && <AmountNegativeBalanceList load={load} setLoad={setLoad} />}
      {selectedPanelStatus === 'Credit' && <CreditNegativeBalanceList load={load} setLoad={setLoad} />}
    </>
  );
};
